import { FIXED_VALUES, TRIP_STATUS } from '@/constants';
import { ITrip } from '~/api/ITrip';

const isLateReasonRequiredFlag = (value: unknown): boolean => {
  if (value == null) {
    return false;
  }

  const normalized = String(value).trim().toLowerCase();
  return normalized === String(FIXED_VALUES.TRUE).toLowerCase() || normalized === '1' || normalized === 'true';
};

export const checkIsLateReasonRequiredForRange = (
  trip: ITrip | null,
  fromStatusId: string | number,
  toStatusId: string | number,
): boolean => {
  if (!trip?.lateStatuses) return false;

  const fromStatus = String(fromStatusId);
  const toStatus = String(toStatusId);

  const fromIndex = TRIP_STATUS.findIndex((status) => status.id === fromStatus);
  const toIndex = TRIP_STATUS.findIndex((status) => status.id === toStatus);

  if (fromIndex === -1 || toIndex === -1 || fromIndex >= toIndex) {
    return false;
  }

  for (let i = fromIndex + 1; i <= toIndex; i += 1) {
    const statusId = TRIP_STATUS[i].id;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-unsafe-call
    const statusEntry = trip.lateStatuses.find(
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      (entry) => entry.statusId === statusId,
    );

    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (isLateReasonRequiredFlag(statusEntry?.lateReasonRequired)) {
      return true;
    }
  }

  return false;
};
